import axios from '../request/http';
import { toFormData } from '../common/descriptions'
const article = {
    // 获取文章列表
    BelongList(params) {
        return axios.get("/hemei-admin/agricultural/goodsBelong/BelongList", { params });
    },
    // 归属状态
    updateStatus(data) {
        return axios.post("/hemei-admin/agricultural/goodsBelong/updateStatus", toFormData(data));
    },
    // 根据归属人id查询归属人详情
    getBelong(params) {
        return axios.get("/hemei-admin/agricultural/goodsBelong/getBelong", { params });
    },
    // 归属人订单收入列表
    income(params) {
        return axios.get("/hemei-admin/agricultural/goodsBelong/getBelong/income", { params });
    },
    // 归属人结算记录列表
    settlement(params) {
        return axios.get("/hemei-admin/agricultural/goodsBelong/getBelong/settlement", { params });
    },
    // 归属人结算总合
    settlementSum(params) {
        return axios.get("/hemei-admin/agricultural/goodsBelong/belong/settlementSum", { params });
    },
    // 乡村商品审核列表
    listRt(params) {
        return axios.get("/hemei-admin/goods/info/goodsExamine/list", { params });
    },
    // 商品详情信息
    detailS(params) {
        return axios.get("/hemei-admin/goods/info/detail", { params });
    },
    // 商品批量审核
    examineS(data) {
        return axios.post("/hemei-admin/goods/info/goods/examine", toFormData(data));
    },
    // 乡村电商服务列表
    villageInfo(params) {
        return axios.get("/hemei-admin/goods/info/village/info", { params });
    },
    // 乡村商品管理
    villageGoodsList(params) {
        return axios.get("/hemei-admin/goods/info/villageGoods/list", { params });
    },
    // 乡村电商基本详情
    villageManageList(params) {
        return axios.get("/hemei-admin/accountManage/village/manageList", { params });
    },
    // 开启关闭服务
    updEcommerce(data) {
        return axios.post("/hemei-admin/villageInfo/updEcommerce", toFormData(data));
    },
    // 升级为电商管理员
    updManageType(data) {
        return axios.post("/hemei-admin/villageInfo/updManageType", toFormData(data));
    },
    // 新增/编辑归属
    addBelong(data) {
        return axios.post("/hemei-admin/agricultural/goodsBelong/addBelong", data);
    },


}

export default article;


// WEBPACK FOOTER //
// ./src/api/village.js